import React from "react";
export default function NPV_Net_Present_Value() {
  return <div>Excel_NPV_Calc</div>;
}
